import { render, staticRenderFns } from "./TableStaff.vue?vue&type=template&id=5fb6fe50&scoped=true&"
import script from "./TableStaff.vue?vue&type=script&lang=js&"
export * from "./TableStaff.vue?vue&type=script&lang=js&"
import style0 from "./TableStaff.vue?vue&type=style&index=0&id=5fb6fe50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6fe50",
  null
  
)

export default component.exports